var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 u-mb-xsmall"},[_c('vue-json-to-table',{attrs:{"data":_vm.jsonObjData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }